import styled from "styled-components";
import { Wallet as AppWallet } from "@low6dev/react-feature-wallet-dpg/dist";
// import { handleError } from "utils";
import { useTranslations, useHandleError } from "hooks";
import { useSelector } from "react-redux";
import history from "router/history";

const StyledWrapper = styled.div`
  padding: 1rem 0 0;
`;

const Wallet = () => {
  const [translations] = useTranslations();

  const [handleError] = useHandleError();

  const { dpgAgeVerified, userId } = useSelector((s) => s.auth);

  const { language } = useSelector((s) => s.app);

  let locale;
  if (language === "dutch") {
    locale = "nl";
  }

  const handleVerifyAgeClicked = () => {
    localStorage.removeItem("fiver_react_access_token");

    const redirect = window.location.href.replace("/wallet", "");

    // const url = `https://idin.scoregames.nl/?user_id=${userId}&redirect=${redirect}`;
    const url = `https://idin.scoregames.nl/?user_id=${userId}`;
    window.location.href = url;

    history.push("/sso-error");
  };

  console.log("dateLocale", locale);

  return (
    <StyledWrapper>
      <AppWallet
        translations={translations}
        dpgAgeVerified={dpgAgeVerified}
        dateLocale={locale}
        hidePinField={false}
        userId={userId}
        onError={handleError}
        onAuthError={handleError}
        onVerifyAgeClicked={handleVerifyAgeClicked}
        currencySymbol={process.env.REACT_APP_CURRENCY_SYMBOL}
        showFonixDeposit={process.env.REACT_APP_SHOW_FONIX_DEPOSIT === "true"}
      />
    </StyledWrapper>
  );
};

export default Wallet;
